import axios from 'axios'

const instance = axios.create({
    baseURL: '/',
    timeout: 54000,
})

export default instance
